/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfCalculateHppdResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfCalculateMinutesInShiftResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfCensusEditPermissionResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfHPPDDtoResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfViewCensusDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewCensusDto } from '../api-models';
// @ts-ignore
import { CreateCensusDto } from '../api-models';
// @ts-ignore
import { GetHppdRequest } from '../api-models';
// @ts-ignore
import { OpeningTemplateDayRelation } from '../api-models';
// @ts-ignore
import { RecalculateHPPDRequest } from '../api-models';
// @ts-ignore
import { UpdateCensusDto } from '../api-models';
/**
 * ComplianceApi - axios parameter creator
 * @export
 */
export const ComplianceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [startTime] 
         * @param {string} [endTime] 
         * @param {number} [facilityId] 
         * @param {number} [unitId] 
         * @param {number} [lunchMinutes] 
         * @param {OpeningTemplateDayRelation} [dayRelation] 
         * @param {number} [patientRatio] 
         * @param {number} [employeeRatio] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceCalculateHppdGet: async (startTime?: string, endTime?: string, facilityId?: number, unitId?: number, lunchMinutes?: number, dayRelation?: OpeningTemplateDayRelation, patientRatio?: number, employeeRatio?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Compliance/calculate-hppd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }

            if (lunchMinutes !== undefined) {
                localVarQueryParameter['lunchMinutes'] = lunchMinutes;
            }

            if (dayRelation !== undefined) {
                localVarQueryParameter['dayRelation'] = dayRelation;
            }

            if (patientRatio !== undefined) {
                localVarQueryParameter['patientRatio'] = patientRatio;
            }

            if (employeeRatio !== undefined) {
                localVarQueryParameter['employeeRatio'] = employeeRatio;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [startTime] 
         * @param {string} [endTime] 
         * @param {number} [lunchMinutes] 
         * @param {OpeningTemplateDayRelation} [dayRelation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceCalculateMinutesInShiftGet: async (startTime?: string, endTime?: string, lunchMinutes?: number, dayRelation?: OpeningTemplateDayRelation, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Compliance/calculate-minutes-in-shift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (lunchMinutes !== undefined) {
                localVarQueryParameter['lunchMinutes'] = lunchMinutes;
            }

            if (dayRelation !== undefined) {
                localVarQueryParameter['dayRelation'] = dayRelation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SPD-62: whether the caller may edit census, and the oldest date they may still change.  The rows of the census list carry their own `canEdit`; this is for the parts of the  screen with no row to read it from, such as the Future Census button.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceCensusEditPermissionGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Compliance/census/edit-permission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} [unitId] 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceCensusGet: async (startDate: string, endDate: string, unitId?: number, facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('complianceCensusGet', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('complianceCensusGet', 'endDate', endDate)
            const localVarPath = `/Compliance/census`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substr(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substr(0,10) :
                    endDate;
            }

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateCensusDto} [updateCensusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceCensusIdPut: async (id: number, updateCensusDto?: UpdateCensusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('complianceCensusIdPut', 'id', id)
            const localVarPath = `/Compliance/census/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCensusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCensusDto} [createCensusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceCensusPost: async (createCensusDto?: CreateCensusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Compliance/census`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCensusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetHppdRequest} [getHppdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceHppdPost: async (getHppdRequest?: GetHppdRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Compliance/hppd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getHppdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RecalculateHPPDRequest} [recalculateHPPDRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceRecalculateHppdPut: async (recalculateHPPDRequest?: RecalculateHPPDRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Compliance/recalculate-hppd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recalculateHPPDRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComplianceApi - functional programming interface
 * @export
 */
export const ComplianceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComplianceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [startTime] 
         * @param {string} [endTime] 
         * @param {number} [facilityId] 
         * @param {number} [unitId] 
         * @param {number} [lunchMinutes] 
         * @param {OpeningTemplateDayRelation} [dayRelation] 
         * @param {number} [patientRatio] 
         * @param {number} [employeeRatio] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complianceCalculateHppdGet(startTime?: string, endTime?: string, facilityId?: number, unitId?: number, lunchMinutes?: number, dayRelation?: OpeningTemplateDayRelation, patientRatio?: number, employeeRatio?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfCalculateHppdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complianceCalculateHppdGet(startTime, endTime, facilityId, unitId, lunchMinutes, dayRelation, patientRatio, employeeRatio, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [startTime] 
         * @param {string} [endTime] 
         * @param {number} [lunchMinutes] 
         * @param {OpeningTemplateDayRelation} [dayRelation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complianceCalculateMinutesInShiftGet(startTime?: string, endTime?: string, lunchMinutes?: number, dayRelation?: OpeningTemplateDayRelation, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfCalculateMinutesInShiftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complianceCalculateMinutesInShiftGet(startTime, endTime, lunchMinutes, dayRelation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary SPD-62: whether the caller may edit census, and the oldest date they may still change.  The rows of the census list carry their own `canEdit`; this is for the parts of the  screen with no row to read it from, such as the Future Census button.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complianceCensusEditPermissionGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfCensusEditPermissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complianceCensusEditPermissionGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} [unitId] 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complianceCensusGet(startDate: string, endDate: string, unitId?: number, facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewCensusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complianceCensusGet(startDate, endDate, unitId, facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateCensusDto} [updateCensusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complianceCensusIdPut(id: number, updateCensusDto?: UpdateCensusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewCensusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complianceCensusIdPut(id, updateCensusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateCensusDto} [createCensusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complianceCensusPost(createCensusDto?: CreateCensusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewCensusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complianceCensusPost(createCensusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetHppdRequest} [getHppdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complianceHppdPost(getHppdRequest?: GetHppdRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfHPPDDtoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complianceHppdPost(getHppdRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RecalculateHPPDRequest} [recalculateHPPDRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complianceRecalculateHppdPut(recalculateHPPDRequest?: RecalculateHPPDRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complianceRecalculateHppdPut(recalculateHPPDRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComplianceApi - factory interface
 * @export
 */
export const ComplianceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComplianceApiFp(configuration)
    return {
        /**
         * 
         * @param {ComplianceApiComplianceCalculateHppdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceCalculateHppdGet(requestParameters: ComplianceApiComplianceCalculateHppdGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfCalculateHppdResponse> {
            return localVarFp.complianceCalculateHppdGet(requestParameters.startTime, requestParameters.endTime, requestParameters.facilityId, requestParameters.unitId, requestParameters.lunchMinutes, requestParameters.dayRelation, requestParameters.patientRatio, requestParameters.employeeRatio, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ComplianceApiComplianceCalculateMinutesInShiftGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceCalculateMinutesInShiftGet(requestParameters: ComplianceApiComplianceCalculateMinutesInShiftGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfCalculateMinutesInShiftResponse> {
            return localVarFp.complianceCalculateMinutesInShiftGet(requestParameters.startTime, requestParameters.endTime, requestParameters.lunchMinutes, requestParameters.dayRelation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SPD-62: whether the caller may edit census, and the oldest date they may still change.  The rows of the census list carry their own `canEdit`; this is for the parts of the  screen with no row to read it from, such as the Future Census button.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceCensusEditPermissionGet(options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfCensusEditPermissionResponse> {
            return localVarFp.complianceCensusEditPermissionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ComplianceApiComplianceCensusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceCensusGet(requestParameters: ComplianceApiComplianceCensusGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewCensusDto> {
            return localVarFp.complianceCensusGet(requestParameters.startDate, requestParameters.endDate, requestParameters.unitId, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ComplianceApiComplianceCensusIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceCensusIdPut(requestParameters: ComplianceApiComplianceCensusIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewCensusDto> {
            return localVarFp.complianceCensusIdPut(requestParameters.id, requestParameters.updateCensusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ComplianceApiComplianceCensusPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceCensusPost(requestParameters: ComplianceApiComplianceCensusPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewCensusDto> {
            return localVarFp.complianceCensusPost(requestParameters.createCensusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ComplianceApiComplianceHppdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceHppdPost(requestParameters: ComplianceApiComplianceHppdPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfHPPDDtoResponse> {
            return localVarFp.complianceHppdPost(requestParameters.getHppdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ComplianceApiComplianceRecalculateHppdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceRecalculateHppdPut(requestParameters: ComplianceApiComplianceRecalculateHppdPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.complianceRecalculateHppdPut(requestParameters.recalculateHPPDRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for complianceCalculateHppdGet operation in ComplianceApi.
 * @export
 * @interface ComplianceApiComplianceCalculateHppdGetRequest
 */
export interface ComplianceApiComplianceCalculateHppdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ComplianceApiComplianceCalculateHppdGet
     */
    readonly startTime?: string

    /**
     * 
     * @type {string}
     * @memberof ComplianceApiComplianceCalculateHppdGet
     */
    readonly endTime?: string

    /**
     * 
     * @type {number}
     * @memberof ComplianceApiComplianceCalculateHppdGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof ComplianceApiComplianceCalculateHppdGet
     */
    readonly unitId?: number

    /**
     * 
     * @type {number}
     * @memberof ComplianceApiComplianceCalculateHppdGet
     */
    readonly lunchMinutes?: number

    /**
     * 
     * @type {OpeningTemplateDayRelation}
     * @memberof ComplianceApiComplianceCalculateHppdGet
     */
    readonly dayRelation?: OpeningTemplateDayRelation

    /**
     * 
     * @type {number}
     * @memberof ComplianceApiComplianceCalculateHppdGet
     */
    readonly patientRatio?: number

    /**
     * 
     * @type {number}
     * @memberof ComplianceApiComplianceCalculateHppdGet
     */
    readonly employeeRatio?: number
}

/**
 * Request parameters for complianceCalculateMinutesInShiftGet operation in ComplianceApi.
 * @export
 * @interface ComplianceApiComplianceCalculateMinutesInShiftGetRequest
 */
export interface ComplianceApiComplianceCalculateMinutesInShiftGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ComplianceApiComplianceCalculateMinutesInShiftGet
     */
    readonly startTime?: string

    /**
     * 
     * @type {string}
     * @memberof ComplianceApiComplianceCalculateMinutesInShiftGet
     */
    readonly endTime?: string

    /**
     * 
     * @type {number}
     * @memberof ComplianceApiComplianceCalculateMinutesInShiftGet
     */
    readonly lunchMinutes?: number

    /**
     * 
     * @type {OpeningTemplateDayRelation}
     * @memberof ComplianceApiComplianceCalculateMinutesInShiftGet
     */
    readonly dayRelation?: OpeningTemplateDayRelation
}

/**
 * Request parameters for complianceCensusGet operation in ComplianceApi.
 * @export
 * @interface ComplianceApiComplianceCensusGetRequest
 */
export interface ComplianceApiComplianceCensusGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ComplianceApiComplianceCensusGet
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof ComplianceApiComplianceCensusGet
     */
    readonly endDate: string

    /**
     * 
     * @type {number}
     * @memberof ComplianceApiComplianceCensusGet
     */
    readonly unitId?: number

    /**
     * 
     * @type {number}
     * @memberof ComplianceApiComplianceCensusGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for complianceCensusIdPut operation in ComplianceApi.
 * @export
 * @interface ComplianceApiComplianceCensusIdPutRequest
 */
export interface ComplianceApiComplianceCensusIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ComplianceApiComplianceCensusIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateCensusDto}
     * @memberof ComplianceApiComplianceCensusIdPut
     */
    readonly updateCensusDto?: UpdateCensusDto
}

/**
 * Request parameters for complianceCensusPost operation in ComplianceApi.
 * @export
 * @interface ComplianceApiComplianceCensusPostRequest
 */
export interface ComplianceApiComplianceCensusPostRequest {
    /**
     * 
     * @type {CreateCensusDto}
     * @memberof ComplianceApiComplianceCensusPost
     */
    readonly createCensusDto?: CreateCensusDto
}

/**
 * Request parameters for complianceHppdPost operation in ComplianceApi.
 * @export
 * @interface ComplianceApiComplianceHppdPostRequest
 */
export interface ComplianceApiComplianceHppdPostRequest {
    /**
     * 
     * @type {GetHppdRequest}
     * @memberof ComplianceApiComplianceHppdPost
     */
    readonly getHppdRequest?: GetHppdRequest
}

/**
 * Request parameters for complianceRecalculateHppdPut operation in ComplianceApi.
 * @export
 * @interface ComplianceApiComplianceRecalculateHppdPutRequest
 */
export interface ComplianceApiComplianceRecalculateHppdPutRequest {
    /**
     * 
     * @type {RecalculateHPPDRequest}
     * @memberof ComplianceApiComplianceRecalculateHppdPut
     */
    readonly recalculateHPPDRequest?: RecalculateHPPDRequest
}

/**
 * ComplianceApi - object-oriented interface
 * @export
 * @class ComplianceApi
 * @extends {BaseAPI}
 */
export class ComplianceApi extends BaseAPI {
    /**
     * 
     * @param {ComplianceApiComplianceCalculateHppdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceApi
     */
    public complianceCalculateHppdGet(requestParameters: ComplianceApiComplianceCalculateHppdGetRequest = {}, options?: AxiosRequestConfig) {
        return ComplianceApiFp(this.configuration).complianceCalculateHppdGet(requestParameters.startTime, requestParameters.endTime, requestParameters.facilityId, requestParameters.unitId, requestParameters.lunchMinutes, requestParameters.dayRelation, requestParameters.patientRatio, requestParameters.employeeRatio, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ComplianceApiComplianceCalculateMinutesInShiftGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceApi
     */
    public complianceCalculateMinutesInShiftGet(requestParameters: ComplianceApiComplianceCalculateMinutesInShiftGetRequest = {}, options?: AxiosRequestConfig) {
        return ComplianceApiFp(this.configuration).complianceCalculateMinutesInShiftGet(requestParameters.startTime, requestParameters.endTime, requestParameters.lunchMinutes, requestParameters.dayRelation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SPD-62: whether the caller may edit census, and the oldest date they may still change.  The rows of the census list carry their own `canEdit`; this is for the parts of the  screen with no row to read it from, such as the Future Census button.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceApi
     */
    public complianceCensusEditPermissionGet(options?: AxiosRequestConfig) {
        return ComplianceApiFp(this.configuration).complianceCensusEditPermissionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ComplianceApiComplianceCensusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceApi
     */
    public complianceCensusGet(requestParameters: ComplianceApiComplianceCensusGetRequest, options?: AxiosRequestConfig) {
        return ComplianceApiFp(this.configuration).complianceCensusGet(requestParameters.startDate, requestParameters.endDate, requestParameters.unitId, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ComplianceApiComplianceCensusIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceApi
     */
    public complianceCensusIdPut(requestParameters: ComplianceApiComplianceCensusIdPutRequest, options?: AxiosRequestConfig) {
        return ComplianceApiFp(this.configuration).complianceCensusIdPut(requestParameters.id, requestParameters.updateCensusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ComplianceApiComplianceCensusPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceApi
     */
    public complianceCensusPost(requestParameters: ComplianceApiComplianceCensusPostRequest = {}, options?: AxiosRequestConfig) {
        return ComplianceApiFp(this.configuration).complianceCensusPost(requestParameters.createCensusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ComplianceApiComplianceHppdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceApi
     */
    public complianceHppdPost(requestParameters: ComplianceApiComplianceHppdPostRequest = {}, options?: AxiosRequestConfig) {
        return ComplianceApiFp(this.configuration).complianceHppdPost(requestParameters.getHppdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ComplianceApiComplianceRecalculateHppdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceApi
     */
    public complianceRecalculateHppdPut(requestParameters: ComplianceApiComplianceRecalculateHppdPutRequest = {}, options?: AxiosRequestConfig) {
        return ComplianceApiFp(this.configuration).complianceRecalculateHppdPut(requestParameters.recalculateHPPDRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
